<div class="claim-usage-ingestion-page">
	<div class="actions-container">
		<div class="action-card">
			<div class="action-info">
				<mat-icon color="accent">cloud_upload</mat-icon>
				<span class="action-title">Upload de sinistros</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="upload-button"
					[class.upload-button-loading]="isUploading"
					[disabled]="isUploading"
					(click)="openUploadDialog()"
				>
					<mat-spinner
						*ngIf="isUploading"
						class="upload-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isUploading"
						class="upload-button-icon"
						svgIcon="sanus-upload"
					></mat-icon>
					<span>Upload do arquivo</span>
				</button>
			</div>
		</div>
	</div>

	<p class="error-message" *ngIf="uploadError">{{ uploadError }}</p>

	<div class="blocked-message" *ngIf="blockedUploadMessage">
		<mat-icon>block</mat-icon>
		<span>{{ blockedUploadMessage }}</span>
	</div>

	<section class="history-card">
		<div class="pre-processing-header">
			<div>
				<h3>Histórico de cargas</h3>
			</div>
		</div>

		<div class="history-loading-state" *ngIf="isHistoryLoading">
			<mat-spinner diameter="20"></mat-spinner>
			<span>Carregando historico de cargas...</span>
		</div>

		<p class="history-warning-message" *ngIf="historyLoadError">
			{{ historyLoadError }}
		</p>

		<div class="history-empty-state" *ngIf="shouldShowHistoryEmptyState">
			<mat-icon>inventory_2</mat-icon>
			<span>Nenhum arquivo de utilização de sinistro foi enviado ainda.</span>
		</div>

		<ng-container *ngIf="hasHistoryItems">
			<div class="history-table-wrapper">
				<table class="history-table">
					<thead>
						<tr>
							<th>Arquivo</th>
							<th>Operadora</th>
							<th>Competência</th>
							<th>Responsável</th>
							<th>Enviado em</th>
							<th>Status de processamento</th>
							<th>Iniciado em</th>
							<th>Finalizado em</th>
							<th>Ações</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="
								let item of historyItems;
								trackBy: trackHistoryItemByJobId
							"
						>
							<td>{{ formatFileName(item.preProcessing.originalFileName) }}</td>
							<td>{{ getHistoryOperator(item) }}</td>
							<td>{{ getHistoryCompetence(item) }}</td>
							<td>{{ getHistoryResponsible(item) }}</td>
							<td>{{ formatDate(item.preProcessing.uploadedAt) }}</td>
							<td>
								<span
									class="status-pill"
									[ngClass]="getStatusPillClass(item.preProcessing.jobStatus)"
								>
									{{ getStatusLabel(item.preProcessing.jobStatus) }}
								</span>
							</td>
							<td>
								{{
									item.postProcessing?.startedAt
										? formatDate(item.postProcessing?.startedAt || '')
										: '-'
								}}
							</td>
							<td>
								{{
									item.postProcessing?.finishedAt
										? formatDate(item.postProcessing?.finishedAt || '')
										: '-'
								}}
							</td>
							<td>
								<div class="history-actions">
									<button
										*ngIf="canDownloadHistoryFile(item)"
										mat-stroked-button
										color="primary"
										class="history-action-button history-download-button"
										(click)="downloadHistoryFile(item)"
										[attr.aria-label]="
											'Baixar arquivo ' +
											formatFileName(item.preProcessing.originalFileName)
										"
									>
										<mat-icon>file_download</mat-icon>
										<span>Download</span>
									</button>
									<button
										mat-stroked-button
										color="primary"
										class="history-action-button"
										(click)="openHistoryDetail(item)"
									>
										Detalhes
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ng-container>
	</section>
</div>
